import { createSlice } from "@reduxjs/toolkit";
import { fetchCountriesData } from "./actions";
import { notification } from "antd";

const initialState = {
    countriesData: [],
    countriesLoading: false,
    countriesError: null,
    totalCount: 0,
};

const countriesSlice = createSlice({
    name: "countries",
    initialState,
    reducers: {
        clearCountriesData: (state) => {
            state.countriesData = [];
            state.totalCount = 0;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCountriesData.pending, (state) => {
                state.countriesLoading = true;
                state.countriesError = null;
            })
            .addCase(fetchCountriesData.fulfilled, (state, action) => {
                state.countriesLoading = false;
                state.countriesData = action.payload.data.countries;
                state.totalCount = action.payload.data.countries.length|| 0;

                const payload = action.payload;
                if (payload?.meta?.status === 'fail') {
                    notification.error({
                        message: "Error",
                        description: payload?.meta?.message,
                        duration: 2,
                    });

                }
            })
            .addCase(fetchCountriesData.rejected, (state, action) => {
                state.countriesLoading = false;
                state.countriesError = action.payload;
                notification.error({
                    message: "Error",
                    description: "Failed to fetch countries data",
                    duration: 2,
                });
            });
    },
});

export const { clearCountriesData } = countriesSlice.actions;
export default countriesSlice.reducer;